import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { categoriesSelector, isAdminSelector } from 'store/selectors';
import NewCategoryItem from 'components/NewCategoryItem';
import MultipleCombobox from 'components/MultipleCombobox';
import { getCategories } from 'store/actions';

const messages = defineMessages({
  categoriesLabel: { id: 'page-settings-modal.page.categories-label' },
  categoriesPlaceholder: {
    id: 'page-settings-modal.page.categories-placeholder',
  },
  categoriesDescription: {
    id: 'page-settings-modal.page.categories-description',
  },
});

const categoryItemToString = (item) => (item ? item.name : '');
const normalizeCategoryItem = (item) => ({ key: item.id, label: item.name });

function CategoriesCombobox({ showNewCategoryItem, value, onChange }) {
  const isAdmin = useSelector(isAdminSelector);

  const intl = useIntl();

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getCategories()).finally(() => {
      setIsLoading(false);
    });
  }, [dispatch]);

  let categories = useSelector(categoriesSelector);

  if (!isAdmin) {
    categories = categories.filter((item) => item.group !== 'layouts');
  }

  return (
    <MultipleCombobox
      label={intl.formatMessage(messages.categoriesLabel)}
      placeholder={intl.formatMessage(messages.categoriesPlaceholder)}
      helperText={intl.formatMessage(messages.categoriesDescription)}
      loading={isLoading}
      items={categories}
      itemToString={categoryItemToString}
      normalizeItem={normalizeCategoryItem}
      // searching for selected categories in categories array
      // because MultipleCombobox compares selected categories with shallow
      // equal and in order to show correct results we need use the same
      // objects
      selectedItems={categories.filter((category) =>
        value.find((item) => item.id === category.id),
      )}
      onSelectedItemsChange={({ selectedItems }) => {
        onChange(selectedItems);
      }}
      footerElement={
        showNewCategoryItem && (
          <NewCategoryItem
            categoriesNames={Object.values(categories).map(
              (category) => category.name,
            )}
          />
        )
      }
      fullWidth
    />
  );
}

CategoriesCombobox.propTypes = {
  showNewCategoryItem: PropTypes.bool,
  value: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CategoriesCombobox;
